<template>
	<!--基础的input-->
	<input :type="type" :id='id' :value='value' :class="classCpt" :style="styleCpt" :maxlength="maxlength"
		   :placeholder="placeholder" :autofocus="autofocus" :readonly="readonly" 
		   @click="$emit('click')" @blur="$emit('blur')"  
		   v-on="inputListeners" :onmousewheel="mouseeheel" />
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
			//如果设定了宽度
			if(this.widthCpt){ 
				this.styleCpt = 'width:' + this.widthCpt;
			}
			//type 为  number 时，禁止鼠标事件
			if(this.onmousewheel === '' && this.onmousewheel != undefined){
				this.mouseeheel = 'return false;';
			}
		},
		props:['type','id','value','widthCpt','classCpt','placeholder',
			   'autofocus','readonly','maxlength','onmousewheel'],
		data(){
			return{
				styleCpt:'', //input 样式
				mouseeheel:''
			}
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					// 我们从父级添加所有的监听器
					this.$listeners,
					//然后我们添加定义监听器，或覆写一些监听器行为
					{
						// 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
				            vm.$emit('input', event.target.value)
				        },
				        //获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
					}
				)
			}
		}
	}
</script>

<style scoped>
	input{ width:50%; padding:0 10px 2px;border:none;border-bottom:1px solid #a9a9a9;}
	
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/input-Base-bk.vue